import React from "react";
import { cls } from "@wss/cls";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { QuantityDiscount } from "~/common/Store/models/ProductListing";
import { formatQuantityDiscountData } from "./QuantityDiscountHelper";
import DivideByPricing from "./DivideByPricing";

interface QuantityDiscountTableRowProps {
  quantity?: QuantityDiscount;
  unitOfMeasure: string;
  mustBuy: number;
  displaySalePrice?: boolean;
  divideByUnit?: string;
  divideQuantity?: number;
  quantityDiscountsModified?: boolean;
  firstQuantityDiscountRowData?: string;
  productPrice: number;
}

const QuantityDiscountTableRow = ({
  quantity = {
    price: 0,
    isLotDiscount: false,
    quantity: 0,
    startQuantity: 0,
    endQuantity: 0,
  },
  unitOfMeasure,
  mustBuy,
  displaySalePrice = false,
  divideByUnit = "",
  divideQuantity = 0,
  quantityDiscountsModified = false,
  firstQuantityDiscountRowData = "",
  productPrice,
}: QuantityDiscountTableRowProps) => {
  const isLotDiscount = quantity.isLotDiscount
    ? `Lots of ${quantity.startQuantity}`
    : formatQuantityDiscountData(
        mustBuy,
        quantity.startQuantity,
        quantity.endQuantity
      );
  return (
    <tr
      className={cls(
        "border-0",
        "border-b",
        "border-solid",
        "border-gray-300",
        !quantityDiscountsModified && "last:border-0"
      )}
    >
      <td
        className={cls(
          "text-xs",
          "font-semibold",
          "py-1.5",
          "border-0",
          "border-r",
          "border-gray-300",
          "border-solid",
          "text-left",
          "px-3",
          "min-w-[58px]"
        )}
      >
        {quantityDiscountsModified
          ? firstQuantityDiscountRowData
          : isLotDiscount}
      </td>
      <td className={cls("pl-2", "py-1.5", "w-full")}>
        <div className={cls("flex", "flex-col", "items-start")}>
          <p className={cls("m-0", "text-xs", "font-bold", "text-red-500")}>
            {quantityDiscountsModified
              ? formatAsCurrency.formatIfUndefined(productPrice)
              : formatAsCurrency.formatIfUndefined(quantity.price)}
            {unitOfMeasure ? (
              <span
                className={cls(
                  "text-2xs",
                  "font-semibold",
                  "leading-4",
                  "text-gray-800"
                )}
              >
                {`/${unitOfMeasure}`}
              </span>
            ) : null}
          </p>
          {!displaySalePrice ? (
            <DivideByPricing
              price={quantityDiscountsModified ? productPrice : quantity.price}
              divideByUnit={divideByUnit}
              divideQuantity={divideQuantity}
              unitFontSize="text-2xs"
              fontColorClassName="text-gray-600"
            />
          ) : null}
        </div>
      </td>
    </tr>
  );
};

export default QuantityDiscountTableRow;
